import { Link } from 'react-router-dom';

import './Error404.css';

const Error404 = () => {

    return (

        <div className="error-page">

            <div className="error-box">

                <h1>404</h1>

                <h2>Page Not Found</h2>

                <p>
                    The page you are looking for does not exist.
                </p>

                <Link to="/dashboard">

                    <button>

                        Back To Dashboard

                    </button>

                </Link>

            </div>

        </div>

    );
}

export default Error404;